<template>
    <b-container>
        <b-row class="my-3">
            <b-col class="product-holder">
                <b-img src="https://s3-media0.fl.yelpcdn.com/bphoto/bkQp1kNqc05uqUpJFlGJkg/300s.jpg" 
                    rounded width="260" height="260"
                />
                <b-img src="https://i.imgur.com/UvWrx6Q.png" 
                    class='plus-image'
                    width="130" height="130"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p class="h5 mb-0">
                    <strong>Best Desserts in Manila</strong>
                </p>
                <p>
                    By Katrina E.
                </p>
            </b-col>
        </b-row>
    </b-container>
</template>

<style scoped>
.product-holder {
    position: relative;
    display: block;
}

.plus-image {
    left: 50%;
    top: 50%;
    position: absolute;
    margin-bottom: -25px;
    margin-right: -25px;
}


</style>

<script>
export default {
    
}
</script>